export const FETCH_WASTE_CATEGORY_REQUEST = 'FETCH_WASTE_CATEGORY_REQUEST'
export const FETCH_WASTE_CATEGORY_SUCCESS = 'FETCH_WASTE_CATEGORY_SUCCESS'
export const FETCH_WASTE_CATEGORY_FALUIRE = 'FETCH_WASTE_CATEGORY_FALUIRE'

